/* LUNA mega menu — D42.
   Attaches a panel section to a header nav item by TITLE (data-parent), the same
   parent_link pattern Flex uses, so the panel works with any menu without child
   links. Waits for DOMContentLoaded (the header/D40 lesson: nav links don't exist
   at parse time). Desktop only — the mobile drawer keeps its own nav. */
(function(){
  if(window.__lunaMega) return; window.__lunaMega = true;

  function init(panel){
    if(panel.__luna) return; panel.__luna = true;
    var want = (panel.dataset.parent || '').trim().toLowerCase();
    if(!want) return;
    var links = Array.prototype.slice.call(document.querySelectorAll('.luna-hd__link'));
    var trigger = links.filter(function(a){ return a.textContent.trim().toLowerCase() === want; })[0];
    if(!trigger) return;

    var hd = trigger.closest('.luna-hd');
    trigger.classList.add('has-mega');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    var closeTimer = null;

    function place(){
      var r = hd.getBoundingClientRect();
      panel.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
    }
    function open(){
      clearTimeout(closeTimer);
      place();
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close(){
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function closeSoon(){
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 140);
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('mouseleave', closeSoon);
    panel.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closeSoon);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && panel.classList.contains('is-open')){ close(); trigger.focus(); }
    });
    document.addEventListener('click', function(e){
      if(!panel.contains(e.target) && e.target !== trigger) close();
    });
    window.addEventListener('scroll', function(){
      if(panel.classList.contains('is-open')) close();
    }, { passive: true });
  }

  function scan(){ document.querySelectorAll('[data-luna-mega]').forEach(init); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();